import { z } from "@/zod";

const shiftReportDepartmentEntry = z.object({
  id: z.string().length(26),
  department_name: z.string(),
  ordered: z.coerce.number().nullable(),
  present: z.coerce.number().nullable(),
});

export const readShiftReportDepartmentEntry =
  shiftReportDepartmentEntry.readonly();

export const writeShiftReportDepartmentEntry = shiftReportDepartmentEntry.omit({
  department_name: true,
});
